<template>
    <div id="app">
        <app-header></app-header>
        <router-view></router-view>
        <app-footer v-if="!blockOfLinks"></app-footer>
    </div>
</template>

<script>
    import Header from './components/Header.vue';
    import Footer from './components/Footer.vue';

    export default {
        components: {
            appHeader: Header,
            appFooter: Footer
        },
        name: 'app',
        data () {
          return {
            blockOfLinks: window.location.host === 'andrew.ooo'
          }
        }

    }
</script>


// WEBPACK FOOTER //
// App.vue?c91b1fec